import { Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges } from '@angular/core';
import { ExecuteCommandService } from '../../services';
import { faChevronDown, faChevronRight, faClipboardCheck, faLink } from '@fortawesome/free-solid-svg-icons';
import { barTone, formatPercent, formatPercentPrecise, gaugeStatus, GaugeStatus } from '../project-summary/summary-ui';

@Component({
  standalone: false,
  selector: 'project-cxplanner-summary',
  templateUrl: './project-cxplanner-summary.component.html',
  styleUrls: ['./project-cxplanner-summary.component.scss'],
})
export class ProjectCxplannerSummmaryComponent implements OnInit, OnChanges, OnDestroy {
  @Input() cxPlannerSummary: any;
  @Input() isActive = true;
  @Input() playToken = 0;
  faCXPlannerLink = faLink;
  faClipboard = faClipboardCheck;
  faChevronDown = faChevronDown;
  faChevronRight = faChevronRight;
  commissioningOverallComplete = 0;
  hasCommissioningStages = false;
  status: GaugeStatus = gaugeStatus(0);
  displayPercent = '0%';
  expandedStageId: any = null;
  showAllStages = false;
  animateBars = false;
  private barTimer: any;

  constructor(public executeCommandService: ExecuteCommandService) { }

  ngOnInit() {
    this.refreshOverallComplete();
  }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['cxPlannerSummary']) {
      this.refreshOverallComplete();
    }
    if (changes['cxPlannerSummary'] || changes['isActive'] || changes['playToken']) {
      this.restartBarAnimation();
    }
  }

  ngOnDestroy() {
    this.clearBarTimer();
  }

  get stages(): any[] {
    return Array.isArray(this.cxPlannerSummary) ? this.cxPlannerSummary : [];
  }

  get visibleStages(): any[] {
    if (this.showAllStages || this.stages.length <= 3) {
      return this.stages;
    }
    return this.stages.slice(0, 3);
  }

  gotoCXPlannerDashboard() {
    window.open('https://app.cxplanner.com/project/' + this.cxPlannerSummary.projectId + '/dashboard', '_blank');
  }

  format(value: number, decimals: number = 0): string {
    return formatPercent(value, decimals);
  }

  formatPrecise(value: number): string {
    return formatPercentPrecise(value);
  }

  tone(value: number): string {
    return barTone(value);
  }

  isExpanded(stage: any): boolean {
    return this.expandedStageId === stage.SummaryStageId;
  }

  toggleStage(stage: any) {
    this.expandedStageId = this.isExpanded(stage) ? null : stage.SummaryStageId;
  }

  private refreshOverallComplete() {
    const stages = this.stages;
    this.hasCommissioningStages = stages.length > 0;
    const values = stages
      .map(stage => Number(stage && stage.PercentComplete))
      .filter(value => !isNaN(value));

    if (!values.length) {
      this.commissioningOverallComplete = 0;
    } else {
      const average = values.reduce((sum, value) => sum + value, 0) / values.length;
      this.commissioningOverallComplete = Math.round(average * 10) / 10;
    }
    this.status = gaugeStatus(this.commissioningOverallComplete);
    this.displayPercent = formatPercent(this.commissioningOverallComplete, 1);
    if (this.expandedStageId == null && stages[0]) {
      this.expandedStageId = stages[0].SummaryStageId;
    }
  }

  private restartBarAnimation() {
    this.animateBars = false;
    this.clearBarTimer();
    if (!this.isActive) {
      return;
    }
    this.barTimer = setTimeout(() => {
      this.animateBars = true;
    }, 30);
  }

  private clearBarTimer() {
    if (this.barTimer) {
      clearTimeout(this.barTimer);
      this.barTimer = null;
    }
  }
}
